import React from 'react';
import { useNavigate } from 'react-router-dom';
import JourneySelection from '../components/JourneySelection';

const JourneySelectionPage = () => {
  const navigate = useNavigate();
  const selectedChild = JSON.parse(localStorage.getItem('selectedChild') || 'null');

  // If no child selected, redirect to child select
  if (!selectedChild) {
    navigate('/child-select');
    return null;
  }

  return (
    <JourneySelection 
      selectedChild={selectedChild}
      onBack={() => navigate('/temple')}
    />
  );
};

export default JourneySelectionPage;
